// old version of jquery ui accordion called jquery ui shutter?

(function (window, $) {

    $.Shutter = function (options, element) {
        this.$el = $(element);
        this.$heightToogle = $(options.selectors.item).height();
        // initialize shutter
        this._init(options);
    };

    $.Shutter.defaults = {
        // selectors to access buttons and items
        selectors: {
            button: 'li a:first',
            item: 'li div.content'
        },
        // prefix to prepend to sh-index data attribute
        namespace: '',
        // index of opened item. -1 means all are closed by default.
        open: -1,
        // if set to true, only one item can be opened. Once one item is opened, any other that is opened will be closed first
        oneOpenedItem: false,
        // css class to mark opened button and item
        opened: 'opened',
        // speed of the open / close item animation
        speed: 600,
        // easing of the open / close item animation
        easing: 'swing',
        // if set to true, will have a fade animation during the open/close effect
        fade: true,
        // if set to true, will have a scroll to action item animation
        scroll: false,
        // speed of the scroll to action animation
        scrollSpeed: 600,
        // easing of the scroll to action animation
        scrollEasing: 'swing',
        // fixed height for bad get.height()
        forcedHeight : false
    };

    $.Shutter.prototype = {
        _init: function (options) {
            this.options = $.extend(true, {}, $.Shutter.defaults, options);

            var namespace = this.options.namespace;

            // list items
            this.$items = this.$el.find(this.options.selectors.item);
            // list buttons
            this.$buttons = this.$el.find(this.options.selectors.button);
            // total number of items
            this.itemsCount = this.$items.length;

            // data-sh-index attributes
            this.$items.each(function (index) {
                $(this).data(namespace + 'sh-index', index);
            });
            this.$buttons.each(function (index) {
                $(this).data(namespace + 'sh-index', index);
            });

            // current is the index of the opened item
            this.current = this.options.open;

            // hide the items so we can fade it in afterwards
            this.$items.hide();

            // if we want a default opened item...
            if (this.current != -1)
                this._toggleItem(this.$items.eq(this.current));

            // initialize the events
            this._initEvents();
        },
        _getRelated: function ($related, $from) {
            var ac_index = this.options.namespace + 'sh-index';
            return $related.filter(function () { return $(this).data(ac_index) == $from.data(ac_index) });
        },
        _initEvents: function () {
            var instance = this;

            // open / close item
            this.$el.find(this.options.selectors.button).bind('click.shutter', function (event) {
                var $item = instance._getRelated(instance.$items, $(this));

                // close any opened item if oneOpenedItem is true
                if (instance.options.oneOpenedItem && instance._isOpened() && instance.current !== parseInt($item.data(instance.options.namespace + 'sh-index'))) {
                    instance._toggleItem(instance.$items.eq(instance.current));
                }

                // open / close item
                instance._toggleItem($item);

                return false;
            });
        },
        // checks if there is any opened item
        _isOpened: function () {
            return (this.$el.find(this.options.selectors.item + '.' + this.options.opened).length > 0);
        },
        // open / close item
        _toggleItem: function ($item) {
            var $button = this._getRelated(this.$buttons, $item);
  
            if ($item.hasClass(this.options.opened)) {
                this.previous = this.current;
                this.current = -1;
                $item.stop(true, true);
                if (this.options.fade) $item.fadeOut({ duration: this.options.speed, queue: false });
                $item.removeClass(this.options.opened);
                $button.removeClass(this.options.opened);
                $item.animate({ height: 0 }, { queue: false, complete: function () { $item.css({ height: '', display: 'none' }); }, duration: this.options.speed, easing: this.options.easing });
            }
            else {
                this.current = parseInt($item.data(this.options.namespace + 'sh-index'));

                var height = (this.options.forcedHeight) ? this.$heightToogle : $item.height();

                var outerHeight = $item.outerHeight();
                $item.css({ height: 0, display: 'block' });
                $item.stop(true, true);
                if (this.options.fade) $item.fadeIn({ duration: this.options.speed, queue: false });
                $item.addClass(this.options.opened);
                $button.addClass(this.options.opened);
                $item.animate({ height: height }, { queue: false, duration: this.options.speed, easing: this.options.easing });

                var positionTop = $item.position().top - (this.options.oneOpenedItem && this.previous >= 0 && this.previous < this.current ? this.$items.eq(this.previous).innerHeight() : 0);
                var $offsetParent = $item.offsetParent();
                var $scroller = this._getScroller($item);
                while ($offsetParent && $offsetParent.parent($scroller).length > 0) {
                    positionTop += $offsetParent.position().top;
                    if ($offsetParent.offsetParent().get(0) !== $offsetParent.get(0))
                        $offsetParent = $offsetParent.offsetParent();
                    else
                        $offsetParent = null;
                }

                if ($scroller.get(0) === document) $scroller = $(window);
                if (this.options.scroll) this._scroll($scroller, positionTop);
                else {
                    if (positionTop + outerHeight - $scroller.scrollTop() > $scroller.height()) {
                        this._scroll($scroller, positionTop + outerHeight - $scroller.height());
                    }
                }
            }

        },
        // scrolls to current item or last opened item if current is -1
        _scroll: function ($scroller, positionTop) {
            if ($scroller.get(0) === window) $scroller = $('body,html');
            $scroller.stop().animate({
                scrollTop: positionTop
            }, this.options.scrollSpeed, this.options.scrollEasing);
        },
        _getScroller: function ($item) {
            var position = $item.css("position"),
                excludeStaticParent = position === "absolute",
                scrollParent = $item.parents().filter(function () {
                    var parent = $(this);
                    if (excludeStaticParent && parent.css("position") === "static") {
                        return false;
                    }
                    return (/(auto|scroll)/).test(parent.css("overflow") + parent.css("overflow-y") + parent.css("overflow-x"));
                }).eq(0);

            return position === "fixed" || !scrollParent.length ? $($item[0].ownerDocument || document) : scrollParent;
        },
    };

    var logError = function (message) {
        if (this.console) {
            console.error(message);
        }
    };

    $.fn.shutter = function (options) {
        if (typeof options === 'string') {
            var args = Array.prototype.slice.call(arguments, 1);

            this.each(function () {
                var instance = $.data(this, 'shutter');

                if (!instance) {
                    logError("cannot call methods on shutter prior to initialization; " +
					"attempted to call method '" + options + "'");
                    return;
                }

                if (!$.isFunction(instance[options]) || options.charAt(0) === "_") {
                    logError("no such method '" + options + "' for shutter instance");
                    return;
                }

                instance[options].apply(instance, args);
            });
        }
        else {
            this.each(function () {
                var instance = $.data(this, 'shutter');
                if (!instance) {
                    $.data(this, 'shutter', new $.Shutter(options, this));
                }
            });
        }

        return this;
    };

})(window, jQuery);
